import React, { memo } from 'react'
import { PageList } from './page-list'
import { PageListGrouped } from './page-list-grouped'
import type { FeedList } from './feed-item-types'

const FeedInnerListWrapper = ({
  visible,
  pages,
  grouped,
  sorted,
  feed,
  domain,
  hideSync,
  onScanEvent,
  demo,
}: FeedList) => {
  return (
    <ul className={!visible ? 'hidden' : undefined} aria-hidden={!visible}>
      {grouped ? <PageListGrouped /> : null}
      <PageList
        pages={pages}
        onScanEvent={onScanEvent}
        sorted={sorted}
        feed={feed}
        domain={domain}
        grouped={grouped}
        demo={demo}
        hideSync={hideSync}
      />
    </ul>
  )
}

export const FeedInnerList = memo(FeedInnerListWrapper)
